import Modal from 'components/Modal';
import Typography from 'components/Typography';
import styles from './CreatePurchaseOrderModal.module.scss';
import Select from 'components/Select';
import {useCreatePurchaseOrder} from './useCreatePurchaseOrder';
import PlusComponent from 'components/PlusComponent';
import Button from 'components/Button';
import NewCustomerModal from 'pages/Members/Customers/NewCustomerModal';
import CreateAddressModal from 'pages/UserForm/CreateAddressModal';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  orderId: number;
  orderItems: number[];
  onSuccess: () => void;
};

function CreatePurchaseOrderModal({
  isOpen,
  onClose,
  orderId,
  orderItems,
  onSuccess,
}: Props) {
  const {
    vendorOptions,
    selectedVendor,
    setSelectedVendor,
    getCustomerAddressesMutation,
    form,
    addressOptions,
    isCreatingPurchaseOrder,
    handleCreatePurchaseOrder,
    vendorModalOpen,
    setVendorModalOpen,
    addressModalOpen,
    setAddressModalOpen,
    refetchVendorList,
    purchaseOrderOptions,
    isAttachingPurchaseOrder,
  } = useCreatePurchaseOrder({orderId, orderItems, onCloseModal});

  function onCloseModal() {
    onClose();
    form.reset();
    setSelectedVendor(null);
    onSuccess();
  }

  console.log(form.watch('pickup_id'));
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        onRequestClose={onClose}
        className={styles.list_wrapper}
      >
        <Typography variant="h2">Create New Purchase Order</Typography>
        <div className={styles.label}>
          <div>Vendor</div>
          <PlusComponent onClick={() => setVendorModalOpen(true)} />
        </div>
        <Select
          placeholder="Click To Select"
          onChange={(item) => {
            setSelectedVendor(item);
            getCustomerAddressesMutation(Number(item?.value));
          }}
          value={selectedVendor}
          menuPosition="fixed"
          options={vendorOptions}
        />
        {Boolean(selectedVendor?.value) && (
          <>
            <div className={styles.label}>
              <div>Address</div>
              <PlusComponent onClick={() => setAddressModalOpen(true)} />
            </div>
            <Select
              placeholder="Click To Select"
              onChange={(item) => {
                form.setValue('address_id', Number(item?.value));
              }}
              value={
                addressOptions.find(
                  (opt) => opt.value === form.watch('address_id')
                ) || null
              }
              menuPosition="fixed"
              options={addressOptions}
            />
            <div className={styles.label}>
              <div>Not Attached Purchase Orders (optional)</div>
            </div>
            <Select
              placeholder="Click To Select"
              onChange={(item) => {
                form.setValue('pickup_id', Number(item?.value));
              }}
              value={
                purchaseOrderOptions?.find(
                  (opt) => opt?.value === form.watch('pickup_id')
                ) || null
              }
              menuPosition="absolute"
              options={purchaseOrderOptions}
            />
          </>
        )}
        <Button
          loading={isCreatingPurchaseOrder || isAttachingPurchaseOrder}
          disabled={
            !selectedVendor ||
            !form.watch('address_id') ||
            isCreatingPurchaseOrder ||
            isAttachingPurchaseOrder
          }
          className={styles.addBtn}
          onClick={handleCreatePurchaseOrder}
        >
          Create Order
        </Button>
      </Modal>
      {vendorModalOpen && (
        <NewCustomerModal
          title="Add New Vendor"
          onSuccess={(data) => {
            setSelectedVendor({
              value: data?.id,
              label: data?.user?.first_name + ' ' + data?.user?.last_name,
            });
            refetchVendorList();
          }}
          defaultClientRole="vendors"
          isOpen={vendorModalOpen}
          onClose={() => setVendorModalOpen(false)}
        />
      )}

      {addressModalOpen && (
        <CreateAddressModal
          title="Add New Vendor Address"
          newAddressType="dispatch"
          customer_id={Number(selectedVendor?.value)}
          handleClose={() => setAddressModalOpen(false)}
          onSuccess={(data) => {
            form.setValue('address_id', Number(data?.id));
            getCustomerAddressesMutation(Number(selectedVendor?.value));
          }}
          isOpen={addressModalOpen}
        />
      )}
    </>
  );
}
export default CreatePurchaseOrderModal;
